import React from 'react';
import { Button } from 'react-bootstrap';
import ResponderBaseModal from './ResponderBaseModal';

const DESTRUCTIVE_BUTTON_STYLE = {
  backgroundColor: 'var(--color-status-danger)',
  borderColor: 'var(--color-status-danger)',
  color: '#ffffff',
  transition: 'none',
  boxShadow: 'none',
};

const ResponderAlertModal = ({
  show = false,
  title = 'Confirm',
  message = '',
  children,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm = () => {},
  onCancel = () => {},
  showCancel = true,
  showFooter = true,
  confirmVariant = 'danger',
  cancelVariant = 'primary',
  centered = true,
  footerLeft = null,
  stackLevel = 2,
}) => {
  const isDestructive = confirmVariant === 'danger';

  const footer = showFooter ? (
    <div className="d-flex justify-content-between align-items-center gap-2 w-100">
      <div>{footerLeft}</div>
      <div className="d-flex gap-2">
        {showCancel ? (
          <Button variant={cancelVariant} onClick={onCancel}>
            {cancelLabel}
          </Button>
        ) : null}
        <Button
          variant={confirmVariant}
          style={isDestructive ? DESTRUCTIVE_BUTTON_STYLE : undefined}
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </div>
    </div>
  ) : null;

  return (
    <ResponderBaseModal
      show={show}
      onHide={onCancel}
      title={title}
      centered={centered}
      className="responder-alert-modal"
      stackLevel={stackLevel}
      footer={footer}
    >
      {children ?? message}
    </ResponderBaseModal>
  );
};

export default ResponderAlertModal;
